import { useEffect, useState } from 'react'
import { Link, Outlet, useLocation, useParams } from 'react-router-dom'

import { getApplication } from '../api/applications.js'
import { FeedbackProvider } from '../components/ui/FeedbackProvider.jsx'
import UserHeaderChip from '../components/ui/UserHeaderChip.jsx'
import logo from '../assets/logo.png'

export default function AppLayout() {
  const { pathname } = useLocation()
  const { id } = useParams()
  const isApplicationsRoute = pathname.startsWith('/applications/')
  const appId = isApplicationsRoute && id ? id : null
  const hasAppId = Boolean(appId)
  const [application, setApplication] = useState(null)

  useEffect(() => {
    if (!hasAppId) {
      setApplication(null)
      return undefined
    }
    let cancelled = false
    getApplication(appId)
      .then((data) => {
        if (!cancelled) setApplication(data)
      })
      .catch(() => {
        if (!cancelled) setApplication(null)
      })
    return () => {
      cancelled = true
    }
  }, [hasAppId, appId])

  return (
    <FeedbackProvider>
      <div className="appShell">
        <header className="appHeader">
          <div className="appHeaderLeft">
            <Link to="/" className="appHeaderHome">
              <img src={logo} alt="" className="appHeaderLogo" />
              <span className="appHeaderTitle">Appquantum Platform</span>
            </Link>
            {hasAppId ? (
              <Link
                to="/applications"
                className="appHeaderApplication"
                aria-label="Back to applications list"
              >
                <div className="applicationHeaderIconWrap" aria-hidden="true">
                  {application?.icon ? (
                    <img src={application.icon} alt="" className="applicationHeaderIcon" />
                  ) : (
                    <div className="applicationHeaderIconFallback">
                      {(application?.name || 'A').slice(0, 1).toUpperCase()}
                    </div>
                  )}
                </div>
                <div className="applicationHeaderMeta">
                  <h2 className="applicationHeaderTitle">
                    {application?.name ? `${application.name} settings` : 'Application settings'}
                  </h2>
                  {application ? (
                    <div className="muted">
                      {application.platform} • {application.bundleId}
                    </div>
                  ) : (
                    <div className="muted">Loading...</div>
                  )}
                </div>
              </Link>
            ) : null}
          </div>
          <div className="appHeaderActions">
            <UserHeaderChip />
          </div>
        </header>

        <div className="main">
          <main className="content">
            <Outlet />
          </main>
        </div>
      </div>
    </FeedbackProvider>
  )
}
